export const MIN_SCREEN_WIDTH_DESKTOP_LARGE = 1400;
export const MIN_SCREEN_WIDTH_DESKTOP = 1024;
export const MIN_SCREEN_WIDTH_TABLET = 768;
export const MAX_SCREEN_WIDTH_TABLET = 1023;
export const MIN_SCREEN_WIDTH_TABLET_SMALL = 640;
export const MAX_SCREEN_WIDTH_TABLET_SMALL = 767;
export const MIN_SCREEN_WIDTH_MOBILE_LARGE = 401;
export const MAX_SCREEN_WIDTH_MOBILE_LARGE = 639;
export const MAX_SCREEN_WIDTH_MOBILE = 400;
export const MIN_SCREEN_WIDTH_MOBILE = 0;
export const NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP_LARGE = 4;
export const NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP = 3;
export const NUMBER_OF_ITEMS_IN_LISTER_ROW_TABLET = 3;
export const NUMBER_OF_ITEMS_IN_LISTER_ROW_TABLET_SMALL = 2;
export const NUMBER_OF_ITEMS_IN_LISTER_ROW_MOBILE_LARGE = 2;
export const NUMBER_OF_ITEMS_IN_LISTER_ROW_MOBILE = 2;
export const NUMBER_OF_ITEMS_IN_LISTER_ROW_DEFAULT = 2;
